/**
 * 盒子-模板封面
 * @author VenDream
 * @since 17/12/14
 */
// 企业专区发模糊背景图
import BLUR_BG_IMG from 'assets/images/blur-bg.png';
// 第三方登陆平台备用封面图
import OPF_EMPLOYEE from 'assets/images/opf-employee.jpg';
// 开放平台加载的备用图
import OPFID_PLACE_HOLDER_IMG from 'assets/images/placeholder-opfid.png';
// 加载失败的备用图
import PLACE_HOLDER_IMG from 'assets/images/placeholder.png';
import VARIABLES from 'constants/variable.json5';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { showRabbitBrandInfo } from 'utils/user';
import './tpl-cover.less';

// 封面滚动速率常量
const COVER_SCROLL_RATIO = 200;
const IMG_CDN = {
  test: 'rp-test.rabbitpre.com',
  oss1: 'oss1.rabbitpre.com',
};
// 企业专区固定封面容器高度
const DEFAULT_COVER_HEIGHT = 337;

export default class TplCover extends Component {
  static propTypes = {
    style: PropTypes.object,
    cover: PropTypes.string,
    category: PropTypes.string,
    isPosterPreview: PropTypes.bool,
    imgStyle: PropTypes.object,
  };

  componentDidMount() {
    const { cover } = this.props;
    this.preloadCover(this.coverImg, cover);
  }

  componentDidUpdate(preProps) {
    //父组件点击，props更改导致子组件二次渲染封面出错
    const { cover } = this.props;
    if (!cover) {
      this.preloadCover(this.coverImg, preProps.cover);
    }
  }
  /**
   * 封面预加载
   * @params {HTMLElement} node    封面img
   * @params {String}      cover   封面图片URL
   */
  preloadCover = (node, cover) => {
    const preloadImg = new Image();
    const { test, oss1 } = IMG_CDN;
    const { category } = this.props;

    // 第三方平台登陆用户
    if (!showRabbitBrandInfo()) {
      if (String(cover).includes('default_cover')) {
        cover = OPF_EMPLOYEE;
      }
    }

    // 获取裁剪后的图片URL
    cover = cover.replace(test, oss1);

    preloadImg.onload = () => {
      setTimeout(() => {
        if (node) {
          node.setAttribute('src', cover);
          if (category === VARIABLES.ENTERPRISE && node.parentNode) {
            node.parentNode.style.backgroundImage = `url(${BLUR_BG_IMG})`;
          }
          const imgH = node.height;
          if (
            imgH < DEFAULT_COVER_HEIGHT &&
            category === VARIABLES.ENTERPRISE &&
            node.parentNode
          ) {
            // 企业专区旧数据，方形封面垂直居中
            node.parentNode.style.alignItems = 'center';
          }
          node.onload = () => {
            node.classList.add('success');
          };
        }
      }, 200);
    };

    preloadImg.src = cover;
  };

  // hover封面滚动
  handleScrollCover = (e, direction) => {
    const target = e.target;
    const { category, isPosterPreview } = this.props;

    if (
      target.nodeName === 'IMG' &&
      (isPosterPreview || category !== VARIABLES.POSTER)
    ) {
      const wrapperH = target.parentNode.getBoundingClientRect().height;
      const imgH = target.getBoundingClientRect().height;
      const deltaH = Math.floor(imgH - wrapperH);
      const translate = direction === 'up' ? deltaH : 0;
      const duration = direction === 'up' ? deltaH / COVER_SCROLL_RATIO : 0;

      if (deltaH <= 0) return;

      target.style.transform = `translate3d(0, ${-translate}px, 0)`;
      target.style.webkitTransform = `translate3d(0, ${-translate}px, 0)`;
      target.style.transitionDuration = `${duration}s`;
    }
  };

  render() {
    const { style, cover, imgStyle } = this.props;
    return (
      <div
        className="tpl-cover"
        style={style}
        key={cover}
        onMouseEnter={e => this.handleScrollCover.call(this, e, 'up')}
        onMouseLeave={e => this.handleScrollCover.call(this, e, 'down')}>
        <img
          style={imgStyle}
          src={
            showRabbitBrandInfo() ? PLACE_HOLDER_IMG : OPFID_PLACE_HOLDER_IMG
          }
          // alt="TPL_COVER"
          className="tpl-cover-img"
          ref={node => (this.coverImg = node)}
        />
      </div>
    );
  }
}
